import request from '@/utils/request'

// 企业资讯列表(首页无权限)
export function examineNoAuthList(query) {
    return request({
        url: '/coal/document/dataFormCoalNew/noAuth/queryList',
        method: 'get',
        params: query
    })
}

// 企业资讯列表
export function examineList(query) {
    return request({
        url: '/coal/document/dataFormCoalNew/powerCoalQueryList',
        method: 'get',
        params: query
    })
}

// 企业资讯详情
export function examineDetail(query) {
    return request({
        url: '/coal/document/dataFormCoalNew/powerCoalExamineList',
        method: 'get',
        params: query
    })
}

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/coal/industry/noAuth/industryList',
        method: 'get',
        params: query
    })
}

// 行业动态二级页/industry/powerCoalList
export function industryPage(query) {
    return request({
        url: `/coal/industry/powerCoalList`,
        method: 'get',
        params: query
    })
}

// 行业动态详情 /industry/powerCoalInfo/{id}
export function industryDetail(id) {
    return request({
        url: `/coal/industry/powerCoalInfo/${id}`,
        method: 'get',
    })
}

// 研究报告列表(首页无权限)/report/powerCoalInfo/{id}
export function reportNoAuthList(query) {
    return request({
        url: '/coal/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 研究报告列表(二级)/report/charredCoalTechnicalInfo/{id}
export function charredCoalList(query) {
    return request({
        url: '/coal/report/powerCoalList',
        method: 'get',
        params: query
    })
}

// 技术及标准列表 /report/powerCoalList
export function reportList(query) {
    return request({
        url: '/coal/report/powerCoalList',
        method: 'get',
        params: query
    })
}

// 技术及标准列表
export function reportLists(query) {
    return request({
        url: '/coal/report/cokeList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/期货主力合约价格/metatron/price/noAuth/powerCoalContractList
export function priceNoAuthList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/powerCoalContractList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/进出口/metatron/price/noAuth/powerCoalImportList
export function coalImportList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/powerCoalImportList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/产地/metatron/price/noAuth/powerCoalPlaceList
export function coalPlaceList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/powerCoalPlaceList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/港口/metatron/price/noAuth/powerCoalPortList
export function coalPortList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/powerCoalPortList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/仓单
export function coalReceiptList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/coalReceiptList',
        method: 'get',
        params: query
    })
}

// 价格列表 产地
export function pricePageCoalPlaceList(query) {
    return request({
        url: '/coal/metatron/price/powerCoalPlaceList',
        method: 'get',
        params: query
    })
}

// 价格列表 港口
export function pricePageCoalPortList(query) {
    return request({
        url: '/coal/metatron/price/powerCoalPortList',
        method: 'get',
        params: query
    })
}

// 价格列表 进口
export function pricePageCoalImportList(query) {
    return request({
        url: '/coal/metatron/price/powerCoalImportList',
        method: 'get',
        params: query
    })
}


// 价格列表 仓单
export function pricePageCoalReceiptList(query) {
    return request({
        url: '/coal/metatron/price/powerCoalReceiptList',
        method: 'get',
        params: query
    })
}

// 价格列表 期货主力合约价格
export function pricePageCoalContractList(query) {
    return request({
        url: '/coal/metatron/price/powerCoalContractList',
        method: 'get',
        params: query
    })
}

// 价格列表
export function pricePage(query) {
    return request({
        url: '/coal/metatron/price/cokeList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: '/coal/metatron/price/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 价格详情 产地 /metatron/price/detailsCoalPlace
export function priceDetailCoalPlace(query) {
    return request({
        url: '/coal/metatron/price/detailsPowerCoalPlace',
        method: 'get',
        params: query
    })
}

// 价格详情 港口/metatron/price/detailsCoalPort
export function priceDetailCoalPort(query) {
    return request({
        url: '/coal/metatron/price/detailsPowerCoalPort',
        method: 'get',
        params: query
    })
}

// 价格详情 进口
export function priceDetailsCoalImport(query) {
    return request({
        url: '/coal/metatron/price/detailsPowerCoalImport',
        method: 'get',
        params: query
    })
}

// 价格详情 仓单
export function priceDetailCoalReceipt(query) {
    return request({
        url: '/coal/metatron/price/detailsPowerCoalReceipt',
        method: 'get',
        params: query
    })
}

// 价格详情 期货主力合约价格/metatron/price/detailsPowerCoalPort
export function priceDetailCoalContract(query) {
    return request({
        url: '/coal/metatron/price/detailsPowerCoalContract',
        method: 'get',
        params: query
    })
}

// 库存列表(首页无权限)
export function stockNoAuthList(query) {
    return request({
        url: '/coal/metatron/stock/noAuth/cokeList',
        method: 'get',
        params: query
    })
}

// 库存列表
export function stockPage(query) {
    return request({
        url: '/coal/metatron/stock/cokeList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: '/coal/metatron/stock/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 开工率列表(首页无权限)
export function rateNoAuthList(query) {
    return request({
        url: '/coal/operate/rate/noAuth/list',
        method: 'get',
        params: query
    })
}

// 开工率列表 /operate/rate/boardList
export function ratePage(query) {
    return request({
        url: '/coal/operate/rate/boardList',
        method: 'get',
        params: query
    })
}

// 开工率详情 /operate​/rate​ / detailsOperateRate
export function rateDetail(query) {
    return request({
        url: '/coal/operate/rate/detailsOperateRate',
        method: 'get',
        params: query
    })
}

// 进出口量列表
export function exitPage(query) {
    return request({
        url: '/coal/metatron/exit/cokeList',
        method: 'get',
        params: query
    })
}

// 进出口量列表(首页无权限)
export function exitNoAuthList(query) {
    return request({
        url: '/coal/metatron/exit/noAuth/cokeList',
        method: 'get',
        params: query
    })
}

// 进出口量详情
export function exitDetail(query) {
    return request({
        url: '/coal/metatron/exit/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 新增淘汰产能列表(首页无权限)
export function boardNoAuthList(query) {
    return request({
        url: '/coal/board/noAuth/list',
        method: 'get',
        params: query
    })
}

// 新增淘汰产能详情
export function boardDetail() {
    return request({
        url: `/coal/board/getCapacityList`,
        method: 'get',
    })
}

// 地图
export function mapData(query) {
    return request({
        url: '/coal/metatron/yield/cokeYieldLine',
        method: 'get',
        params: query
    })
}

// 地图/operate/rate/lineChart 开工率
export function ratemapData(query) {
    return request({
        url: '/coal/operate/rate/lineChart',
        method: 'get',
        params: query
    })
}

// 地图
export function mapDatas(query) {
    return request({
        url: '/coal/metatron/price/cokeLineChart',
        method: 'get',
        params: query
    })
}

// 地图第一个
export function mapOneDatas(query) {
    return request({
        url: '/coal/metatron/price/cokeLineChart',
        method: 'get',
        params: query
    })
}

// 企业产能 （首页无权限）
export function getNoAuthCompanyCoke(query) {
    return request({
        url: '/coal/metatron/companyCoke/noAuth/queryList',
        method: 'get',
        params: query
    })
}

// 研究报告详情 powerCoalTechnicalInfo/report/powerCoalInfo/{id}
export function reportDetail(id) {
    return request({
        url: `/coal/report/powerCoalInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: `/coal/report/powerCoalTechnicalList`,
        method: 'get',
        params:query
    })
}

// 技术标准详情
export function standardDetail(id) {
    return request({
        url: `/coal/report/charredPowerCoalTechnicalInfo/${id}`,
        method: 'get',
    })
}

//全国产量 （首页无权限）
export function cokeYieldLine(query) {
    return request({
        url: '/coal/metatron/yield/noAuth/cokeYieldLine',
        method: 'get',
        params: query
    })
}

// 企业产能 （详情）
export function detailsCokeYield(query) {
    return request({
        url: '/coal/metatron/yield/detailsCokeYield',
        method: 'get',
        params: query
    })
}

// 企业产能 （按炉型产能分布 ）
export function getListGroupByModel(query) {
    return request({
        url: '/coal/metatron/companyCoke/getListGroupByModel',
        method: 'get',
        params: query
    })
}

// 企业产能 （全国产能焦化区域分布）
export function getListRegionalDistribution(query) {
    return request({
        url: '/coal/metatron/companyCoke/getListRegionalDistribution',
        method: 'get',
        params: query
    })
}

// 企业产能 （产能焦化一览）
export function companyCokeList(query) {
    return request({
        url: '/coal/metatron/companyCoke/queryList',
        method: 'get',
        params: query
    })
}

// 讨论区
export function bulletinList(query) {
    return request({
        url: '/coal/bulletin/list',
        method: 'get',
        params: query
    })
}

// 新增讨论
export function addBulletin(data) {
    return request({
        url: '/coal/bulletin',
        method: 'post',
        data: data
    })
}

// 动力煤产量/原煤
export function coalRawYieldList(query) {
    return request({
        url: '/coal/metatron/yield/noAuth/powerCoalRawYieldList',
        method: 'get',
        params: query
    })
}

// 动力煤产量/进出口/metatron/yield/noAuth/coalImportYieldList
export function coalImportYieldList(query) {
    return request({
        url: '/coal/metatron/yield/noAuth/powerCoalImportYieldList',
        method: 'get',
        params: query
    })
}

// 动力煤产量/原煤
export function rawYieldList(query) {
    return request({
        url: '/coal/metatron/yield/powerCoalRawYieldList',
        method: 'get',
        params: query
    })
}

// 动力煤产量/进出口/metatron/yield/noAuth/coalImportYieldList
export function importYieldList(query) {
    return request({
        url: '/coal/metatron/yield/powerCoalImportYieldList',
        method: 'get',
        params: query
    })
}

// 焦煤产量详情/原煤metatron​/yield​ / detailsCoalRawYield
export function detailsCoalRawYield(query) {
    return request({
        url: '/coal/metatron/yield/detailsPowerCoalRawYield',
        method: 'get',
        params: query
    })
}

// 焦煤产量详情/进出口//metatron/yield/detailsCoalImportYield
export function detailsCoalImportYield(query) {
    return request({
        url: '/coal/metatron/yield/detailsPowerCoalImportYield',
        method: 'get',
        params: query
    })
}

// 电厂日耗 无权
export function noAuthDayElectricList(query) {
    return request({
        url: '/coal/metatron/electric/noAuth/dayElectricList',
        method: 'get',
        params: query
    })
}

// 电厂发电量 无权 /metatron/electric/noAuth/hairElectricList
export function noAuthHairElectricList(query) {
    return request({
        url: '/coal/druidEnter/noAuth/queryPage',
        method: 'get',
        params: query
    })
}

// 电厂日耗 有权
export function dayElectricList(query) {
    return request({
        url: '/coal/druidEnter/stockPowerCoalList',
        method: 'get',
        params: query
    })
}

// 电厂发电量 有权 /metatron/electric/hairElectricList
export function hairElectricList(query) {
    return request({
        url: '/coal/metatron/electric/hairElectricList',
        method: 'get',
        params: query
    })
}

// 日耗详情 metatron/electric/detailsHairElectricYieldList
export function detailsHairElectricYieldList(query) {
    return request({
        url: `/coal/druidEnter/getPowerCoalElectricDetailInfo`,
        method: 'get',
        params: query
    })
}

// 电厂发电量 详情 /metatron/electric/detailsDayElectricYieldList
export function detailsDayElectricYieldList(query) {
    return request({
        url: `/coal/metatron/electric/detailsHairElectricYieldList`,
        method: 'get',
        params: query
    })
}

// 地图权限
export function mapAuth(query) {
    return request({
        url: '/coal/metatron/map/powerCoalMap',
        method: 'get',
        params: query
    })
}

// 环渤海库存列表
export function stockList(query) {
    return request({
        url: '/coal/druidEnter/stockPowerCoalList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockSeaDetail(query) {
    return request({
        url: '/coal/druidEnter/getPowerCoalElectricDetailInfo',
        method: 'get',
        params: query
    })
}

// 三年地图
export function lineData(query) {
    return request({
        url: '/coal/metatron/price/cokeLineChart',
        method: 'get',
        params: query
    })
}
